<template>
  <div v-if="visible" class="modal-mask">
    <div class="modal-card">
      <button class="modal-close" @click="$emit('close')">×</button>
      <h3>加盟咨询</h3>
      <p>扫码填写表单，24小时内招商专员联系您</p>
      <img src="@/assets/jiameng.png" alt="小程序码" class="modal-qrcode">
    </div>
  </div>
</template>
<script>
export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  emits: ['close']
}
</script>